import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-access-denied-invitation',
    templateUrl: './access-denied-invitation.component.html',
    styleUrls: ['./access-denied-invitation.component.scss'],
    standalone: false
})
export class AccessDeniedInvitationComponent {

  llttfpage=true;
  constructor(private route:ActivatedRoute) { }

  ngOnInit(){
     this.route.params.subscribe(params=>{
      if(params['programname'] == 'bb')
      {
        this.llttfpage=false;
      }
     })
  }
}
